<template>
	<div class="global-list-points">
		<div v-for="(item, i) in data" :key="i" class="global-list-points__item">
			{{ i18nService.$tDynamic('components.list', item.text) }}
			<a v-if="item.mail" :href="`mailto:${item.mail}`">
				<ButtonUnderlined class="global-list-points__mail">{{ $t('components.list.contact_with_us') }}</ButtonUnderlined>
			</a>
			<ButtonUnderlined v-if="item.intercom" class="global-list-points__mail" @click="openIntercom">{{
				$t('components.list.contact_with_us')
			}}</ButtonUnderlined>
		</div>
	</div>
</template>

<script setup lang="ts">
const { openIntercom } = IntercomService()

interface GlobalListData {
	text: string
	subList?: GlobalListData[]
	mail?: string
	intercom?: boolean
}

defineProps<{
	data: GlobalListData[]
}>()

const i18nService = usei18nService()
</script>

<style lang="scss">
@import './Points';
</style>
